import React, { useEffect } from "react";
import HeaderImageSection from "../shared/headerImageSection";
import Header from "../header/header";
import FooterComponent from "../footerComponent/footerComponent";
import CallIcon from "../../assets/footer/phone.svg";
import EmailIcon from "../../assets/footer/email.svg";
import BusinessIcon from "../../assets/footer/building.svg";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <HeaderImageSection />
      <section className="p-4 sectionContainer bg-white mt-4">
        <div className="row">
          <div className="col-sm-6 textDarkRed">
            <div className="row">
              <div className="col">
                <p className="font28px font-bold text-dark">
                  <b>Kumbhar Mangalam Marriage Matrimony</b>
                </p>
                <p className="pl-2">
                  <img alt="" src={EmailIcon} className="d-inline-block mr-3" />
                  kumbharmangalaam@gmail.com
                </p>
                <p className="font22px pl-2">
                  <img alt="" src={CallIcon} className="d-inline-block mr-3" />
                  9272183132
                </p>
                <div className="d-flex text-left">
                  <p>
                    <img
                      alt=""
                      src={BusinessIcon}
                      className="d-inline-block footerBuildingIcon"
                    />
                  </p>
                  <p className="font16px">
                    <i>
                      Office No. 4, 2nd Floor, Darekar Chordia Complex, Opposite
                      Pandit Petrol Pump, Aditya Birla Hospital Marg, Opposite
                      Bank Of Maharashtra Branch Thergaon, Tathwade, Pune 33.
                    </i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.1710126943713!2d73.75653817798272!3d18.611376337376903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9001711f573%3A0x5859f23f038da83d!2sDarekar%20Heights!5e0!3m2!1sen!2sin!4v1737791339752!5m2!1sen!2sin"
              // width="600"
              // height="450"
              className="googleMap"
              //style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              title='Map'
            ></iframe>
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
};

export default Contact;
